
import IconClose from '@svg/IconClose.svg'
import IconInfo from '@svg/IconInfo.svg'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    'icon-close': IconClose,
    'icon-info': IconInfo,
  },
})
export default class NotificationVue extends Vue {
  @Prop({ type: Boolean, default: true })
  public useDefaultIcon!: boolean
  @Prop({ type: Boolean, default: true })
  public persist!: boolean

  private isActive: boolean = true

  private closeNotification() {
    this.isActive = false
  }
}
